module.exports = __webpack_public_path__ + "bb7aca9fd156c4388c4ac6f494db503c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_image.svg
// module id = 5ocZ
// module chunks = 5